import { Skeleton, Stack } from "@mui/material";
import type { FC } from "react";

export const GoalListItemSkeleton: FC = () => (
	<Stack
		direction="row"
		alignItems="center"
		gap={1.2}
		px={1.6}
		py={1.2}
		width="100%"
	>
		<Skeleton
			variant="rounded"
			width={40}
			height={40}
			sx={(theme) => ({ borderRadius: theme.radii.lg, flexShrink: 0 })}
			animation="wave"
		/>
		<Stack flex={1} minWidth={0} gap={0.4}>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				gap={1}
			>
				<Skeleton variant="text" width="55%" height={18} animation="wave" />
				<Skeleton variant="text" width={56} height={14} animation="wave" />
			</Stack>
			<Skeleton
				variant="rounded"
				height={6}
				sx={{ borderRadius: 3, opacity: 0.5 }}
				animation="wave"
			/>
			<Skeleton variant="text" width="45%" height={14} animation="wave" />
		</Stack>
		<Skeleton
			variant="circular"
			width={16}
			height={16}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
	</Stack>
);
